export default __webpack_public_path__ + "resources/icons/n311-ed8f.webp";